import { useEffect, useState } from "react";
import * as API from './api/api-admin';

import './Admin.css';

import imgBackIcon from './img/back-icon.png';
import imgRefreshIcon from './img/refresh-icon.png';


export default function Admin() {

    const [ sessionList, setSessionList ] = useState(null);
    const [ selectedSession, setSelectedSession ] = useState(null);
    const [ sessionData, setSessionData ] = useState(null);
    const [ accessCode, setAccessCode ] = useState('');

    useEffect(() => {
        if(sessionList === null) {
            API.AdminSessionsList().then(data => {
                console.log('AdminSessionsList API response:', data);
                setSessionList(data.Items || []); 
            }).catch(err => {
                console.error('Error fetching sessions:', err);
                setSessionList([]); 
            });
        }
    }, [sessionList]);


    function handleSessionDetails(sessionId) {
        setSelectedSession(sessionId);
    }

    function GetSelectedItem() {
        if(selectedSession) {
            return sessionList.find(session => session.Id === selectedSession);
        }        
        return {};
    }

    useEffect(() => {
        if (selectedSession) {
            LoadSessionData()
        }
    }, [selectedSession]);

    
    function handleScanSessions() {
        API.AdminSessionsScan().then(data => {
            console.log('AdminSessionsScan API response:', data);
            setSessionList(null); 
        }).catch(err => {
            console.error('Error scanning sessions:', err);
            setSessionList([]); 
        });
        
    }

    function handleChangeSessionStatus() {
        API.AdminChangeSessionStatus(selectedSession).then(data => {
            setAccessCode(data.AccessCode || '');
        }).catch(err => {
            //console.error('Error changing session status:', err);
            //setSessionData(null); 
        });
    }

    function handleRefreshSession() {
        LoadSessionData()
    }

    function LoadSessionData() {
        if (selectedSession) {
            API.AdminSessionDetails(selectedSession).then(data => { 
                console.log('SessionDetails API response:', data);
                setSessionData(data);
                setAccessCode(data.AccessCode || '');
            }).catch(err => {
                console.error('Error fetching session details:', err);
                setSessionData(null); 
            });
        }
    }

  return (
    <div className="form-container form-container-500 white-background padding20">
        { /*
        <h2>Admin Panel</h2>
        <p style={{ textAlign: 'center' }}>Here you can manage sessions and view results.</p>
         */}
        { selectedSession && (
            <div className="session-details">
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '30px', marginBottom: '20px' }}>
                    <button className="btn-nav-admin" onClick={() => setSelectedSession(null)}><img src={imgBackIcon} alt="Back" /></button>
                    <button className={`btn-access-code ${accessCode ? 'session-active' : 'session-inactive'}`} onClick={handleChangeSessionStatus}>
                        {accessCode}
                    </button>
                    <button className="btn-nav-admin" onClick={handleRefreshSession}><img src={imgRefreshIcon} alt="Refresh" /></button>
                </div>

                <p>{GetSelectedItem().Description}</p>

                <div>
                    {sessionData && sessionData.Users && sessionData.Users.length > 0 ? (
                        <div>
                            <br /><br/>
                            <table className="results-table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Duration</th>
                                        <th>Points</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sessionData.Users.map((user, index) => (
                                        <tr key={index}>
                                            <td>{user.Name}</td>
                                            <td>{user.Duration}</td>
                                            <td>{user.Points3}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            
                        </div>
                    ) : (
                        <p>No user data available.</p>
                    )}
                </div>
            </div>
        )}

        { !selectedSession && (
            <>
                {sessionList === null ? (
                    <p style={{ textAlign: 'center' }}>Loading sessions...</p>
                ) : sessionList.length === 0 ? (
                    <p style={{ textAlign: 'center' }}>No sessions found.</p>
                ) : (
                    <>
                        {sessionList.map((session, index) => (
                            <div key={index} className="session-item" onClick={() => handleSessionDetails(session.Id)}> 
                                <strong>{session.Description}</strong>  <div className="session-item-status"> {session.Status}</div>
                            </div>
                        ))}
                    </>
                )}

                    <br /><br /><br />
                {/*}
                <button type="button" className="btn-height45" onClick={handleScanSessions}>
                    Scan Sessions
                </button>
                */}

                <input type="file" id="fileInput" style={{ display: 'none' }} onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                        API.AdminUploadFile(file).then(data => {
                            console.log('AdminUploadSession API response:', data);
                            setSessionList(null); 
                        }).catch(err => {
                            console.error('Error uploading session:', err);
                            setSessionList([]); 
                        });
                    }
                }} />

                <button type="button" className="btn-height45" onClick={() => document.getElementById('fileInput').click()}>
                    Add file
                </button>
            </>
            
        ) }



    </div>
  );
}